import './button.scss';

export default function Button(props) {
    const { onClick, children, className, type, disabled = false } = props;

    return <button type={type || 'button'} className={`btn ${className || ''}`} onClick={onClick} disabled={disabled}>{children}</button>
}